// src/hooks/useChatAnalytics.js

export const useChatAnalytics = (isPlatform) => {

  // Track user message sent
  const trackUserMessage = (chatbotId, messageLength) => {
    // Only track for non-platform/embed usage and if tracking is loaded
    if (!isPlatform && typeof window !== 'undefined') {
      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'message_sent', 'true');
        window.clarity('set', 'chatbot_id', chatbotId);
      }
    }
  };

  // Track bot response received
  const trackBotResponse = (chatbotId, responseLength) => {
    // Only track for non-platform/embed usage and if tracking is loaded
    if (!isPlatform && typeof window !== 'undefined') {
      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'bot_responded', 'true');
      }
    }
  };

  // Track chat opened/closed
  const trackChatToggle = (chatbotId, isOpen) => {
    if (!isPlatform && typeof window !== 'undefined') {
      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'chat_state', isOpen ? 'open' : 'closed');
        window.clarity('set', 'chatbot_id', chatbotId);
      }
    }
  };

  // Track form submissions
  const trackFormSubmission = (chatbotId, formType) => {
    if (!isPlatform && typeof window !== 'undefined') {
      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'form_submitted', 'true');
        window.clarity('set', 'form_type', formType);
      }
    }
  };

  // Track menu interactions
  const trackMenuInteraction = (chatbotId, menuItemId) => {
    if (!isPlatform && typeof window !== 'undefined') {
      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'menu_interaction', 'true');
        window.clarity('set', 'menu_item', menuItemId);
      }
    }
  };

  // Track issue reports
  const trackIssueReport = async (chatbotId, reportData, baseUrl = '') => {
    if (typeof window !== 'undefined') {
      try {
        const endpoint = `${baseUrl}/api/issues/report`;
        await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ chatbotId, ...reportData })
        });
        console.log('[SmushChat] Issue reported to:', endpoint);
      } catch (err) {
        console.error('[SmushChat] Failed to report issue:', err);
      }

      // Track in Clarity (only if loaded and available)
      if (window.clarity) {
        window.clarity('set', 'issue_reported', 'true');
        window.clarity('set', 'issue_element', reportData.tagName);
      }
    }
  };

  return {
    trackUserMessage,
    trackBotResponse,
    trackChatToggle,
    trackFormSubmission,
    trackMenuInteraction,
    trackIssueReport
  };
}; 